import { Database, Model } from '@vuex-orm/core'

const database = new Database()

// Get all model files including those in subdirectories
const modules = import.meta.glob('@/store/models/**/*.js', { eager: true })

Object.values(modules).forEach(module => {
  if (module.default && module.default.prototype instanceof Model) {
    database.register(module.default, module.store)
  }
})

export default database
